import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { Mail, ArrowLeft } from 'lucide-react';
import { toast } from 'sonner';
import { Logo } from '../components/Logo';
import { API } from '../config';

const inputStyle = { background: 'rgba(0,0,0,0.2)', border: '1px solid rgba(255,255,255,0.1)', color: '#F8FAF9' };
const cardStyle = { background: 'rgba(255,255,255,0.03)', border: '1px solid rgba(255,255,255,0.1)' };
const playfairFont = "'Playfair Display', serif";

export const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const [maskedEmail, setMaskedEmail] = useState('');
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await axios.post(`${API}/auth/forgot-password`, { email: email.trim().toLowerCase() });
      setMaskedEmail(data.masked_email);
      setSent(true);
      toast.success(data.message);
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Gagal mengirim link reset');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-6" style={{ background: '#080C0A' }}>
      <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} className="w-full max-w-md">
        <div className="text-center mb-8">
          <Logo size={64} animated={false} />
          <h1 className="text-3xl font-light mt-3" style={{ fontFamily: playfairFont, color: '#F8FAF9' }}>Lupa Password</h1>
          <p className="text-xs mt-1 tracking-[0.2em] uppercase" style={{ color: '#A3B8AC' }}>Reset via Email</p>
        </div>

        <div className="rounded-2xl p-8 backdrop-blur-2xl" style={cardStyle}>
          {!sent ? (
            <form onSubmit={submit} className="space-y-5" data-testid="forgot-form">
              <p className="text-sm" style={{ color: '#CFE0D5' }}>Masukkan email akun Anda. Kami akan kirim tautan reset password jika email terdaftar.</p>
              <div>
                <label className="block text-sm mb-2" style={{ color: '#A3B8AC' }}>Email</label>
                <div className="relative">
                  <Mail className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5" style={{ color: '#A3B8AC' }} />
                  <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required
                    className="w-full rounded-lg pl-12 pr-4 py-3.5 outline-none" style={inputStyle}
                    placeholder="anda@email.com" data-testid="forgot-email-input" />
                </div>
              </div>
              <button type="submit" disabled={loading}
                className="w-full rounded-full px-8 py-3.5 font-medium disabled:opacity-50"
                style={{ background: '#D4AF37', color: '#080C0A' }} data-testid="forgot-submit-btn">
                {loading ? 'Mengirim...' : 'Kirim Link Reset'}
              </button>
            </form>
          ) : (
            <div className="text-center" data-testid="forgot-sent">
              <Mail className="w-16 h-16 mx-auto mb-4" style={{ color: '#D4AF37' }} />
              <p className="text-sm mb-2" style={{ color: '#CFE0D5' }}>Jika email <strong style={{ color: '#F8FAF9' }}>{maskedEmail}</strong> terdaftar, link reset password sudah kami kirim. Cek inbox (dan folder spam).</p>
              <p className="text-xs mt-3" style={{ color: '#A3B8AC' }}>Link berlaku 30 menit.</p>
            </div>
          )}
          <div className="mt-6 text-center text-sm">
            <Link to="/login" className="inline-flex items-center gap-1" style={{ color: '#D4AF37' }} data-testid="back-to-login">
              <ArrowLeft className="w-3 h-3" /> Kembali ke Login
            </Link>
          </div>
        </div>
      </motion.div>
    </div>
  );
};
